// a colletion of functions used across multiple searches
import Search from "../search";

class SearchUtility {
  static clearFiltersClick() {
      // if clear filters exists
      let clearFiltersElement = document.getElementById("clearFilters");
      if (clearFiltersElement) {
          let button = clearFiltersElement.querySelector("button");
          if (button) {
              button.click();
          }
      }
  }

  static setTag(item: any) {
    // add coloured tags to search results
    item.tags = [];
   
    if(item.siteName == "_sait.ca SYO") {
      item.saitYouth = true;
      item.tags.push({
        color: "purple",
        title: "SAIT Youth Programs",
      });
    }
    
    if (item.type == "ProgramPage" || item.type == "ProgramPageV2" ) {
      item.tags.push({
        color: "dark-blue",
        title: "Program",
      });
      if (item.recordObj.isMicroCredential == true) {
        item.saitMicro = true;
        item.tags.push(
          {
            color: "teal-green",
            title: "Continuing Education",
          }
          //,
          // {
          //   color: "teal-green",
          //   title: "SAITMicro",
          // }
        );
      }
    } else if (item.type == "CampDetail") {
      item.tags.push({
        color: "purple",
        title: "Summer Camp",
      });
    } else if (item.type == "Event") {
      item.saitEvent = true;
      item.tags.push({
        color: "fiord-green",
        title: "Events",
      });
    } else if (item.type == "Post") {
      item.saitNews = true;
      item.tags.push({
        color: "jungle-green",
        title: "News",
      });
    } else if (item.type == "ConEdPage") {
      item.isConEdPage = true;
      item.tags.push({
        color: "teal-green",
        title: "Continuing Education",
      });
      if (item.recordObj.isMicroCredential == true) {
        item.saitMicro = true;
        // item.tags.push({
        //   color: "teal-green",
        //   title: "SAITMicro",
        // });
      }
    } else if (item.type == "Document") {
        item.saitPDF = true;
        item.tags.push({
          color: "dark-blue",
          title: "Document",
        });
    }
    else if(item.type == "ExpertBioPage"){
      if(item.recordObj.isStaffBioPage == true){
        item.tags.push({
          color: "dark-grey",
          title: "Staff Directory",
        });
      }
    }
    // add new tags of pod cast and people
    if (item.searchTypes.includes("People")) {
      if(item.recordObj.theme == "staffDirectory")
      {
        item.isStaffBio = true;
      }
      item.tags.push({
        color: "dark-grey",
        title: "People",
      });
    } else if(item.searchTypes.includes("Podcasts")) {
      item.tags.push({
        color: "dark-grey",
        title: "Podcasts",
      });
    }
    return item;
  }

  static setBreadcrumbs(item: any) {
    let url = item.url;
    let bcArray = [];
    let bc;
    let lowerWords = [
      'and', 'at', 'of'
    ];

    if (item && url) {
        if(url.includes("assets/documents/")){
            bcArray = url.split("/").slice(5);
            bcArray.pop();
        } else if(!item.recordObj.isDestiny && item.recordObj.type != "Post" && item.recordObj.type != "Event") {
            bcArray = url.split("/").slice(3);
            bcArray.pop();
        }
    }
    
    bc = bcArray.map(text => {
      let words = text.split('-');
      let breadcrumb = [];

      //do proper capitalization
      words.forEach(el => {
        if (el === "sait"){
          breadcrumb.push("SAIT");
        } else if (!lowerWords.includes(el)){
          breadcrumb.push(el.charAt(0).toUpperCase() + el.slice(1));
        } else {
          breadcrumb.push(el);
        };
      });
      return breadcrumb.join(' ');
    }); 

    item.breadcrumbs = bc;
    return item;
  };

  static onloadFilterParameters(filterName: string) {
    let urlSearchParams = new URLSearchParams(window.location.search);
    let element = document.querySelector(
      `[data-filter-name="${filterName}"]`
    ) as HTMLSelectElement;

    // force select to update value on URL parms
    let selectElement = function (valueToSelect: string) {
      if (element !== null) {
        element.value = valueToSelect;
        element.dispatchEvent(new Event("change"));
      }
    };

    if (urlSearchParams !== null) {
      // get url parms and select filters based on values
      if (urlSearchParams.has(element.dataset.name)) {
        var delivery = urlSearchParams.get(element.dataset.name);
        if (delivery !== null) {
          selectElement(delivery);
        }
      }
    }
  }

  static tabsClickEvents(
    search: Search,
    searchBox: HTMLElement,
    pageType: string,
    isSYO: Boolean
  ) {
    
    let programsTab = document.getElementById("programsTab");
    if(programsTab){
       programsTab.addEventListener("click", function () {
        search.removeFacet("recordObj.type");
        search.removeFacet("recordObj.newProgram");
        if (!isSYO) {
          //SYO pages does not contain these filters
          search.removeFacet(
            "recordObj.categories.programClassification.categoryAoi.value"
          );
          search.removeFacet("recordObj.categories.categorySchools.value");
        }
        search.addFacet({
          field: "recordObj.type",
          value: pageType,
        });
        SearchUtility.clearFiltersClick();
        SearchUtility.setAOIOrSchoolPage(search, searchBox);
        search.search.helper.search();
      });
    }

    if (document.getElementById("conEdTab") !== null) {
      document
        .getElementById("conEdTab")
        .addEventListener("click", function () {
          search.removeFacet("recordObj.type");
          search.removeFacet("recordObj.newProgram");
          if (!isSYO) {
            //SYO pages does not contain these filters
            search.removeFacet(
              "recordObj.categories.programClassification.categoryAoi.value"
            );
            search.removeFacet("recordObj.categories.categorySchools.value");
          }
          search.addFacet({
            field: "recordObj.type",
            value: "ConEdPage",
          });
          SearchUtility.clearFiltersClick();
          SearchUtility.setAOIOrSchoolPage(search, searchBox);
          search.search.helper.search();
        });
    }
    if (document.getElementById("newTab") != null) {
      document.getElementById("newTab").addEventListener("click", function () {
        search.removeFacet("recordObj.type");
        search.removeFacet("recordObj.categories.programClassification.categoryAoi.value");
        search.removeFacet("recordObj.categories.categorySchools.value");
        search.addFacet({
          field: "recordObj.type",
          value: pageType,
        });
        search.addFacet({
          field: "recordObj.newProgram",
          value: "true",
        });
        SearchUtility.clearFiltersClick();
        SearchUtility.setAOIOrSchoolPage(search, searchBox);
        search.search.helper.search();
      });
    }
  }

  public static setAOIOrSchoolPage(search: Search, searchBox: HTMLElement) 
  {
    if (searchBox !== null) {
      let category = searchBox.getAttribute("data-filter-category");
      let filterList = searchBox.getAttribute("data-filter-list");
      if (filterList !== null && filterList == "areaOfInterest") {
        //select aoi filter when its an AOI Page search
        search.addFacet({
          field: "recordObj.categories.programClassification.categoryAoi.value",
          value: category,
        });
      } else if (filterList !== null && filterList == "schools") {
        //select school filter when its a School Page search
        search.addFacet({
          field: "recordObj.categories.categorySchools.value",
          value: category,
        });
      } else if (filterList !== null && filterList == "audience") {
        // select audience for Apprenticeship search
        search.addFacet({
          field: "recordObj.categories.categoryAudience.value",
          value: category,
        });
        if (category == "internationalStudents") {
          let conTab = document.getElementById("conEdTab");
          if (conTab) {
            conTab.classList.add("d-none");
          }
        }
      } else if (filterList !== null && filterList == "credential") {
        search.addFacet({
          field: "recordObj.filterCredential",
          value: category,
        });
      }
    }
  }

  public static getClearExclusionList (search: Search, searchBox: HTMLElement){
    let clearExcludeFilters = [];
    if (searchBox !== null) {
      let category = searchBox.getAttribute("data-filter-category");
      let filterList = searchBox.getAttribute("data-filter-list");
      if (filterList !== null && filterList == "areaOfInterest") {
        clearExcludeFilters.push("recordObj.categories.programClassification.categoryAoi.value");
      }
      else if (filterList !== null && filterList == "schools") {
        clearExcludeFilters.push("recordObj.categories.categorySchools.value");
      }
      else if (filterList !== null && filterList == "audience") {
        clearExcludeFilters.push("recordObj.categories.categoryAudience.value");
      }
      else if (filterList !== null && filterList == "credential"){
        clearExcludeFilters.push("recordObj.filterCredential");
      }
      return clearExcludeFilters;
    }

  }
}

export default SearchUtility;
